// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__21NKR","file":"styles_file__1ej6Y"};